export default "__VITE_ASSET__CnHwqnnr__"